import _classCallCheck from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isAnimationControls } from '../../../animation/utils/is-animation-controls.mjs';
import { createAnimationState } from '../../../render/utils/animation-state.mjs';
import { Feature } from '../Feature.mjs';

var AnimationFeature = /*#__PURE__*/function (_Feature) {
  _inherits(AnimationFeature, _Feature);

  var _super = _createSuper(AnimationFeature);

  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  function AnimationFeature(node) {
    var _this;

    _classCallCheck(this, AnimationFeature);

    _this = _super.call(this, node);
    node.animationState || (node.animationState = createAnimationState(node));
    return _this;
  }

  _createClass(AnimationFeature, [{
    key: "updateAnimationControlsSubscription",
    value: function updateAnimationControlsSubscription() {
      var _this$node$getProps = this.node.getProps(),
          animate = _this$node$getProps.animate;

      this.unmount();

      if (isAnimationControls(animate)) {
        this.unmount = animate.subscribe(this.node);
      }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */

  }, {
    key: "mount",
    value: function mount() {
      this.updateAnimationControlsSubscription();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$node$getProps2 = this.node.getProps(),
          animate = _this$node$getProps2.animate;

      var _ref = this.node.prevProps || {},
          prevAnimate = _ref.animate;

      if (animate !== prevAnimate) {
        this.updateAnimationControlsSubscription();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);

  return AnimationFeature;
}(Feature);

export { AnimationFeature };